<template>
  <v-card class="mb-3">
    <v-system-bar dark :color="color" style="width: 100%">
      <v-icon center>{{data.element_type==='folder' ? 'mdi-folder' : 'mdi-rhombus-medium'}}</v-icon>
      <v-toolbar-title class="ml-1 pointer" :class="{'striked':data.deleted}" @click="expanded=!expanded">{{data.name}}</v-toolbar-title>
      <v-icon>{{expanded?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
      <v-spacer></v-spacer>
      <v-tooltip top v-if="data.deleted">
        <v-btn slot="activator" small icon class="ma-0" @click="$emit('restore')"><v-icon class="mx-0">mdi-restore</v-icon></v-btn>
        <span>Восстановить</span>
      </v-tooltip>
      <v-tooltip top v-else>
        <v-btn slot="activator" small icon class="ma-0" @click="$emit('edit')"><v-icon class="mx-0">mdi-pencil</v-icon></v-btn>
        <span>Редактировать</span>
      </v-tooltip>
      <v-tooltip top>
        <v-btn slot="activator" small icon class="ma-0" @click="$emit('close')"><v-icon class="mx-0">close</v-icon></v-btn>
        <span>Закрыть</span>
      </v-tooltip>
    </v-system-bar>
    <v-card-text class="objects-list pa-2" v-show="expanded">
      <div class="my-2" v-if="data.element_type==='property' && cardObject">
        <p class="pa-0 mt-1 pull-left">Цвет: </p>
        <div :style="{display:'inline-block', border: '1px solid black', marginLeft:'10px', cursor: 'inherit' , width:'60px', height: '30px', background: cardObject.color}"></div>
      </div>
      
      <p v-if="data.element_type==='object' && cardObject.unit"><span class="body-2">Ед. измерения: </span>{{cardObject.unit}}</p>
      
      <div v-if="cardObject.description" v-html="cardObject.description"></div>
  
      <template v-if="data.element_type==='folder' && this.data.tree_type==='property' && cardObject.modules && cardObject.modules.length>0">
        <p class="mb-0">Доступ для модулей</p>
        <v-data-table :headers="headers" :items="cardObject.modules" hide-actions no-data-text="Данные отсутствуют" class="obj-props-table">
          <template slot="items" slot-scope="{item, index}">
            <td>{{modules[item.id]}}</td>
            <td>
              <v-checkbox v-model="item.open" class="justify-center ma-0 pa-0" color="primary" hide-details></v-checkbox>
            </td>
          </template>
        </v-data-table>
      </template>
      
      <template v-if="data.element_type==='object' && cardObject.properties && cardObject.properties.length>0">
        <p class="body-2 mb-1">Признаки объекта учета</p>
        <v-data-table :items="cardObject.properties" hide-headers hide-actions no-data-text="Данные отсутствуют" class="obj-props-table">
          <template slot="items" slot-scope="{item, index}">
            <td><v-icon size="16">{{getIcon(item.element_type)}}</v-icon> {{item.name}}</td>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import all_modules from '../../available_modules'
  import entities from '@/mixins/entities'
  
  export default {
    name : "ConstructorCard",
    
    mixins: [entities],
    
    computed:{
      color(){
        let color = 'primary'
        switch(this.data.element_type){
          case 'property':
            color = 'panel'
            break
          case 'object':
            color = 'warning'
            break
          case 'folder':
            color = (this.data.tree_type==='property') ? 'primary' : 'secondary'
            break
        }
        return color
      },
      modules(){
        return all_modules
      }
    },
    
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    
    created(){
      switch(this.data.element_type){
        case 'property':
          this.$store.dispatch('analytics/constructor/getProperty', this.data.id).then( response => {
            this.cardObject = response
          })
        break
        case 'object':
          this.$store.dispatch('analytics/constructor/getObject', this.data.id).then( response => {
            this.cardObject = response
            this.convertArrayobjects(this.cardObject.properties)
          })
        break
        case 'folder':
          this.$store.dispatch('analytics/constructor/getFolder', {id: this.data.id, type: this.data.tree_type}).then( response => {
            this.cardObject = response
          })
        break
      }
    },
    
    data(){
      return {
        loaded: false,
        cardObject: {},
        expanded: true,
        headers: [
          { text: 'Модуль', align: 'left', sortable: false },
          { text: 'Открыть папку', align: 'center', sortable: false, width: 40 },
        ],
      }
    },
    
    methods:{
      getIcon(type){
        switch(type){
          case 'post': return 'mdi-account'; break;
          case 'container': return 'mdi-account-group'; break;
          default: return 'mdi-rhombus-medium'
        }
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/ConstructorCard.vue